// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.user-profile[data-v-73968b0a] {\n    padding: 32px 10px 30px 15px;\n    display: none;\n}\n.user-content[data-v-73968b0a] {\n    padding-top: 16px;\n}\n.user-content__widget[data-v-73968b0a] {\n    margin-bottom: 32px;\n}\n@media (min-width: 768px) {\n.user-profile[data-v-73968b0a] {\n        display: block;\n}\n.user-content[data-v-73968b0a] {\n        overflow: visible;\n        padding-top: 32px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
